import ssc from './ssc';
// import hpten from './hpten';
// import pk10 from './pk10';
// import ks from './ks';

export default (type, data, ballindex, Vue) => {
  if (type == 'ssc' || type == 'hpten') {
    return ssc(data, ballindex);
  }
  // if (type == 'hpten') {
  //   return hpten(data, ballindex);
  // }
  if (type == 'PK10' || type == 'nn') {
    // return pk10(data);
    return ssc(data, ballindex);
  }
  // if (type == 'ks') {
  //   return ks(data);
  // }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Liangmianshujutongji/columns/index.js